import { useState, useEffect, useCallback, useMemo } from 'react'
import { useParams } from 'react-router'
import useRouter from 'utils/useRouter'
import { useVestigioService } from 'hooks/useVestigioService'

export const useFormTermoNaoConformidade = () => {
  const router = useRouter()
  const params = useParams()
  const vestigioService = useVestigioService()

  const [processandoOperacao, setProcessandoOperacao] = useState(false)
  const [espelhoAberto, setEspelhoAberto] = useState(false)
  const [naoConformidade, setNaoConformidade] = useState('')
  const [perito, setPerito] = useState(null)
  const [processandoPerito, setProcessandoPerito] = useState(false)
  const [testemunha, setTestemunha] = useState(null)
  const [processandoTestemunha, setProcessandoTestemunha] = useState(false)
  const [exameSolicitadoSelecionado, setExameSolicitadoSelecionado] = useState(null)
  const [examesSolicitados, setExamesSolicitados] = useState([])
  const [dataNaoConformidade, setDataNaoConformidade] = useState(null)

  const fetchExamesDoVestigio = useCallback(async () => {
    try {
      const response = await vestigioService.listarVestigioComExameSolicitado(params.idVestigio, setProcessandoOperacao)
      setExamesSolicitados(response?.exSols || [])
    } catch (error) {
      console.error('Erro ao listar exames do vestígio:', error)
      setExamesSolicitados([])
    }
  }, [params.idVestigio])

  const confirmarOperacao = useCallback(async () => {
    const dados = {
      nao_conformidade_constatada: naoConformidade || null,
      id_perito: perito?.id,
      id_usuario_testemunha: testemunha?.id,
      id_exame_solicitado: exameSolicitadoSelecionado?.id,
      id_vestigio: params.idVestigio,
      data_nao_conformidade: dataNaoConformidade,
    }

    try {
      await vestigioService.gerarTermoNaoConformidade(params.idVestigio, dados, setProcessandoOperacao)
      router.history.push(`/casos/caso/vestigio/detalhar/${params.idVestigio}`)
    } catch (error) {
      console.error('Erro ao gerar termo de não conformidade:', error)
    }
  }, [params.idVestigio, perito, testemunha, naoConformidade, exameSolicitadoSelecionado, dataNaoConformidade, vestigioService, router])

  const handleClickBotaoConfirmar = useCallback(() => {
    setEspelhoAberto(true)
  }, [])

  const handleChangePerito = useCallback((value) => {
    setPerito(value)
  }, [])

  const handleChangeTestemunha = useCallback((value) => {
    setTestemunha(value)
  }, [])

  const handleDataTermoNaoConformidade = useCallback((value) => {
    setDataNaoConformidade(value)
  }, [])

  useEffect(() => {
    fetchExamesDoVestigio()
  }, [fetchExamesDoVestigio])

  const isFormValid = useMemo(() => {
    return !!(
      naoConformidade?.trim() &&
      exameSolicitadoSelecionado?.id &&
      dataNaoConformidade
    )
  }, [naoConformidade, exameSolicitadoSelecionado, dataNaoConformidade])

  return {
    naoConformidade,
    setNaoConformidade,
    perito,
    processandoPerito,
    setProcessandoPerito,
    testemunha,
    processandoTestemunha,
    setProcessandoTestemunha,
    exameSolicitadoSelecionado,
    setExameSolicitadoSelecionado,
    examesSolicitados,
    dataNaoConformidade,
    processandoOperacao,
    espelhoAberto,
    setEspelhoAberto,
    confirmarOperacao,
    handleClickBotaoConfirmar,
    handleChangePerito,
    handleChangeTestemunha,
    handleDataTermoNaoConformidade,
    isFormValid,
    router,
    params,
  }
}
